import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserProfileService } from './user-profile.service';
import { filter } from 'rxjs/internal/operators/filter';

@Injectable({
  providedIn: 'root'
})
export class LocaleService {

  readonly DEFAULT_LANG_VALUE = 'en';
  readonly allowLanguages = ['it', this.DEFAULT_LANG_VALUE, 'fr', 'de', 'es', 'pt'];

  constructor(
    private translate : TranslateService,
  ) { }

  configureLanguage(lang : string){
    if(this.allowLanguages.includes(lang.toLowerCase())){
      this.translate.setDefaultLang(lang.toLowerCase());
    }else{
      this.translate.setDefaultLang(this.DEFAULT_LANG_VALUE);
    }
  }

}
